import { BrowserRouter, Route, Switch } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import AdminOrganizationPage from "./pages/AdminOrganizationPage";
import AdminLicenceRenewalPage from "./pages/AdminLicenceRenewalPage";
import AdminUserPage from "./pages/AdminUserPage";
import ProjectPage from "./pages/ProjectPage";
import PermitTypePage from "./pages/PermitTypePage";
import ReferenceProcedurePage from "./pages/ReferenceProcedurePage";
import OrgRolePage from "./pages/OrgRolePage";
import AdminRolePage from "./pages/AdminRolePage";
import DocumentTypePage from "./pages/DocumentTypePage";
import ConfigurationPage from "./pages/ConfigurationPage";
import OrgUserPage from "./pages/OrgUserPage";
import LicencePage from "./pages/LicencePage";
import RegisterDashboardPage from "./pages/RegisterDashboardPage";
import OrgMetricsDashboardPage from "./pages/OrgMetricsDashboardPage";
import DocumentPage from "./pages/DocumentPage";
import PermitPage from "./pages/PermitPage";
import ViewPage from "./pages/ViewPage";
import AddPermitPage from "./pages/AddPermitPage";
import RequestPermitPage from "./pages/RequestPermitPage";
import GangMemberPage from "./pages/GangMemberPage";
import { SemanticToastContainer } from "react-semantic-toasts";
import AuthorizeRoute from "./components/api-authorization/AuthorizeRoute";
import { ApplicationPaths } from "./components/api-authorization/ApiAuthorizationConstants";
import ApiAuthorizationRoutes from "./components/api-authorization/ApiAuthorizationRoutes";
import { Worker } from "@react-pdf-viewer/core";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import "semantic-ui-less/semantic.less";
import { AppContextProvider } from "./contextProviders/AppContextProvider";
import AdminInvoiceItemPage from "./pages/AdminInvoiceItemPage";
import AdminPermitBlueprintPage from "./pages/AdminPermitBlueprintPage";

function App() {
  const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") || "/";

  return (
    <>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.js">
        <BrowserRouter basename={baseUrl}>
          <AppContextProvider>
            <Switch>
              {/* Auth routes must come FIRST — before /:orgName — so /authentication/* 
                  is never matched by the /:orgName AuthorizeRoute catch-all */}
              <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
              <AuthorizeRoute path="/" component={HomePage} exact />
              <AuthorizeRoute path="/settings" component={AdminSettingsPage} exact />
              <AuthorizeRoute path="/settings/organizations" component={AdminOrganizationPage} exact />
              <AuthorizeRoute path="/settings/licence-renewals" component={AdminLicenceRenewalPage} exact />
              <AuthorizeRoute path="/settings/invoice-items" component={AdminInvoiceItemPage} exact />
              <AuthorizeRoute path="/settings/admin-users" component={AdminUserPage} exact />
              <AuthorizeRoute path="/settings/permit-blueprints" component={AdminPermitBlueprintPage} exact />
              <AuthorizeRoute path="/:orgName/home" component={HomePage} exact />
              <AuthorizeRoute path="/:orgName/dashboard" component={HomePage} exact />
              <AuthorizeRoute path="/:orgName/metrics-dashboard" component={OrgMetricsDashboardPage} exact />
              <AuthorizeRoute path="/:orgName/gang-members" component={GangMemberPage} exact />
              <AuthorizeRoute path="/:orgName/reference-procedures" component={ReferenceProcedurePage} exact />
              <AuthorizeRoute path="/:orgName/projects" component={ProjectPage} exact />
              <AuthorizeRoute path="/:orgName/settings/permit-types" component={PermitTypePage} exact />
              <AuthorizeRoute path="/:orgName/settings/roles" component={OrgRolePage} exact />
              <AuthorizeRoute path="/:orgName/settings/admin-roles" component={AdminRolePage} exact />
              <AuthorizeRoute path="/:orgName/settings/document-types" component={DocumentTypePage} exact />
              <AuthorizeRoute path="/:orgName/settings/configurations" component={ConfigurationPage} exact />
              <AuthorizeRoute path="/:orgName/users" component={OrgUserPage} exact />
              <AuthorizeRoute path="/:orgName/licences" component={LicencePage} exact />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/view"
                component={ViewPage}
                exact
              />
              {/* <AuthorizeRoute path="/:orgName/projects/:projectName/dashboard" component={ProjectDashboardPage} exact /> */}
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/dashboard"
                component={RegisterDashboardPage}
                exact
              />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/permits/add-permit/:permitId"
                component={AddPermitPage}
                exact
              />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/permits/add-permit"
                component={AddPermitPage}
                exact
              />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/permits/add-permit/renew/:sourceId"
                component={AddPermitPage}
                exact
              />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/permits/request-permit/:permitId"
                component={RequestPermitPage}
                exact
              />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/permits/request-permit"
                component={RequestPermitPage}
                exact
              />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/permits/request-permit/renew/:sourceId"
                component={RequestPermitPage}
                exact
              />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/permits"
                component={PermitPage}
                exact
              />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/settings"
                component={RegisterDashboardPage}
                exact
              />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle/documents"
                component={DocumentPage}
                exact
              />
              <AuthorizeRoute
                path="/:orgName/projects/:projectName/registers/:registerTitle"
                component={RegisterDashboardPage}
                exact
              />
              <AuthorizeRoute path="/:orgName" component={HomePage} exact />
            </Switch>
          </AppContextProvider>
        </BrowserRouter>
      </Worker>
      <SemanticToastContainer position="top-center" animation="slide up" />
    </>
  );
}

export default App;
